import React, { CSSProperties } from "react"
import { MobergButton, MobergButtonShape } from "../MobergButton/MobergButton"
import { MobergFontFamily } from "../MobergFont/MobergFont"
import { MobergTheme } from "../MobergThemes/MobergColors"

type MobergMenuItemProps = {
    disabled?: boolean
    tooltip?: string
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => void
    icon?: React.ReactNode
    theme?: MobergTheme
    style?: CSSProperties
}

export const MobergContextMenuItem: React.FC<MobergMenuItemProps> = ({ children, disabled, tooltip, onClick, icon, theme, style }) => {
    return (
        <MobergButton shape={MobergButtonShape.FULL_WIDTH} onClick={onClick} disabled={disabled} tooltip={tooltip}
            theme={theme ?? MobergTheme.BLACK}
            style={{
                fontFamily: MobergFontFamily.REGULAR,
                padding: "2px",
                borderRadius: "2px",
                gap: "8px",
                fontWeight: "normal",
                fontSize: "12px",
                justifyContent: "space-between",
                ...style
            }}>
            {children}
            {icon && <span>{icon}</span>}
        </MobergButton>
    )
}
